import React, {useState} from 'react';
import './AdminLibrary.scss';
import DataLibrary from './DataLibrary/DataLibrary';
import { idLibraryCreate, idLibraryUpdate } from '../../../MainVIew/Library/libraryslice';



const AdminLibrary = (props) => {
    const {dispatch} = props;
   // const selectedItem = props.libraryData.selectedLibraryContent;
   // console.log(selectedItem);
const [id, setId] = useState('');   
const [writers, setWriters] = useState();
const [titles, setTitles] = useState();
const [year, setYear] = useState();
const [content, setContent] = useState();
const [category, setCategory] = useState(1);


//HANDLE WRITERS
const handleWriters = (event) => {
    const names = event.target.value;
    setWriters(names);
}
//HANDLE TITLES
const handleTitles= (event) => {
    const titles = event.target.value;
    setTitles(titles);
}
//HANDLE YEAR
const handleYear= (event) => {
    const year = event.target.value;
    setYear(year);
}
//HANDLE CONTENT
const handleContent= (event) => {
    const content = event.target.value;
    setContent(content);
}
//HANDLE CCATEGORY
const handleCategory= (event) => {
    const category = event.target.options[event.target.selectedIndex].value;
    console.log(category);
    setCategory(category);
}


    //ADD ID ITEM LIBRARY
    const onAdd = () => {
        const item = {
            writers: writers,
            titles: titles,
            category: category,
            year: year,
            content: content
        }
        dispatch(idLibraryCreate(item));
    }
  // CHANGE STATE IF EDIT ITEM LIBRARY
  
  const changeOnEditItem = (item) => {
    console.log(item);
    
    setId(item.id);
    setWriters(item.writers);
    setTitles(item.titles);
    setCategory(item.category);
    setYear(item.year);
    setContent(item.content);
  }
  // ON EDIT LIBRARY ITEM
  const onEditItemLibrary =() => {
    const item = {
        id:id,
        writers: writers,
        titles: titles,
        category: category,
        year: year,
        content: content
    }
    dispatch(idLibraryUpdate(item));

  }


       
        const view = props.viewLibrary;
        if(view) {
            return (
            <div className='AdminLibrary'>
                <div className="enterContainer">
                       <p>Литература</p>
                       <div className="container">
                        <label>Авторы</label>
                       <textarea className='writer' value={writers} onChange={handleWriters}></textarea>
                       <label>Наименование</label>
                       <textarea className='title' value={titles} onChange={handleTitles}></textarea>
                       <label>Содержание</label>
                       <textarea  className='content' value={content} onChange={handleContent}></textarea>
                       <label>Год</label>
                       <input value={year} onChange={handleYear}/>
                       <label>Категория</label>
                       <select name="category"   onChange={handleCategory}>
                            <option value="1" >Общее по конструкциям</option>
                            <option value="2">Железобетонные конструкции</option>
                            <option value="3">Стальные конструкции</option>
                            <option value="4">Деревянные конструкции</option>
                            <option value="5">Основания и фундаменты</option>
                            <option value="6">Строительная механика</option>
                            <option value="7">Сопротивление материалов</option>
                            <option value="8">Нагрузки и воздействия</option>
                            <option value="9">Строительные материалы</option>
                            <option value="10">Строительное производство</option>
                            <option value="11">Архитектура зданий</option>

                        </select>
                      
                        <button onClick={onAdd}>Добавить</button>
                        <button onClick={onEditItemLibrary}>Обновить</button>                 
                        </div>
                    
                        
    
    
                    
                </div>
                <div>
                <DataLibrary 
                    libraryData={props.libraryData}
                    dispatch={dispatch}
                    onChangeItem={changeOnEditItem}
                />
                </div>
            </div>
            )
        } else return null;
        

    
}
export default AdminLibrary;